import { render, staticRenderFns } from "./DeleteDocumentFormModal.vue?vue&type=template&id=e5178d68&scoped=true&"
import script from "./DeleteDocumentFormModal.vue?vue&type=script&lang=js&"
export * from "./DeleteDocumentFormModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDocumentFormModal.vue?vue&type=style&index=0&id=e5178d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5178d68",
  null
  
)

component.options.__file = "DeleteDocumentFormModal.vue"
export default component.exports